import { IS_SERVER_RENDER } from '@namespace/helpers';

export const isPWA = (): boolean => {
  const params = new URLSearchParams(window.location.search);

  return IS_SERVER_RENDER
    ? false
    : window.matchMedia('(display-mode: standalone)').matches ||
        params.get('mode') === 'standalone';
};
